import Vue from 'vue'
import vuetify from './plugins/vuetify' // path to vuetify export
import { currentStore as store } from './models/sitestore'
import CustomMenuVue from './components/custom_menu/custom_menu.vue'
Vue.component('custom-menu', CustomMenuVue);

var custom_menu = new Vue({
    vuetify,
    data: {
        store: store,
        success: "",
        error: "",
        snackbar: false
    },
    template: `<div id="app" class="vuetifyjs mcnee-meals-container">
<link href="https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900" rel="stylesheet">
<link href="https://cdn.jsdelivr.net/npm/@mdi/font@6.x/css/materialdesignicons.min.css" rel="stylesheet">
<v-app id="customMenuVue"><v-main><custom-menu /></v-main></v-app></div>`,
    methods: {
    }
});

export { custom_menu }

window.$ = window.jQuery;

$(document).ready(() => {
    var data = {};
    if (window.menu)
        data = window.menu;
    if (window.subscription)
        data = window.subscription;
    store.set(data, {parse: true});
    custom_menu.$mount(".mcnee-meals-container");
});
